import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PuppyApplication.css";

export default function PuppyApplicationSuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="puppy-app-page">
      <div className="puppy-app-header fade-up">
        <div>
          <p className="puppy-app-kicker">Puppy Purchase Application</p>
          <h1 className="puppy-app-title">Application submitted</h1>
        </div>
        <p className="puppy-app-intro">
          Thank you for completing the application. Your submission has been
          received for review.
        </p>
      </div>

      <div className="puppy-app-form fade-up">
        <div className="success-panel">
          <h2>Submission complete</h2>
          <p>
            We will review your application and reach out if we have any
            questions.
          </p>
        </div>

        <div className="review-actions">
          <button
            type="button"
            className="secondary-btn"
            onClick={() => navigate("/puppy-application")}
          >
            Start new application
          </button>
          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/")}
          >
            Back to home
          </button>
        </div>
      </div>
    </div>
  );
}
